import { Navigate, Route, Routes } from 'react-router-dom';

import { Layout } from '@/components/Layout';
import { useAuthStore } from '@/features/auth/authStore';
import { LoginPage } from '@/features/auth/LoginPage';
import { RegisterPage } from '@/features/auth/RegisterPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { WinesListPage } from '@/features/wines/WinesListPage';
import { WineDetailPage } from '@/features/wines/WineDetailPage';
import { WineFormPage } from '@/features/wines/WineFormPage';
import { QuickPricePage } from '@/features/wines/QuickPricePage';
import { TastingForm } from '@/features/tastings/TastingForm';
import { TastingWizard } from '@/features/tastings/TastingWizard';
import { TastingsListPage } from '@/features/tastings/TastingsListPage';
import { PhotoTastingPage } from '@/features/tastings/PhotoTastingPage';
import { PurchasesPage } from '@/features/purchases/PurchasesPage';
import { InventoryPage } from '@/features/inventory/InventoryPage';
import { ImportPage } from '@/features/imports/ImportPage';
import { CatalogPage } from '@/features/catalog/CatalogPage';
import { VerticalsPage } from '@/features/verticals/VerticalsPage';
import { BoxesListPage } from '@/features/boxes/BoxesListPage';
import { BoxEditorPage } from '@/features/boxes/BoxEditorPage';
import { LocationsPage } from '@/features/locations/LocationsPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.token);
  return token ? <>{children}</> : <Navigate to="/login" replace />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="wines" element={<WinesListPage />} />
        <Route path="wines/new" element={<WineFormPage />} />
        <Route path="wines/:id" element={<WineDetailPage />} />
        <Route path="wines/:id/edit" element={<WineFormPage />} />
        <Route path="wines/:id/price" element={<QuickPricePage />} />
        <Route path="tastings" element={<TastingsListPage />} />
        <Route path="tastings/photo" element={<PhotoTastingPage />} />
        <Route path="tastings/new" element={<TastingWizard />} />
        <Route path="tastings/:id/edit" element={<TastingWizard />} />
        {/* Editor rápido con tabs (legacy, lo dejamos por si querés saltar al final) */}
        <Route path="tastings/new/tabs" element={<TastingForm />} />
        <Route path="tastings/:id/edit/tabs" element={<TastingForm />} />
        <Route path="verticals" element={<VerticalsPage />} />
        <Route path="boxes" element={<BoxesListPage />} />
        <Route path="boxes/:id" element={<BoxEditorPage />} />
        <Route path="locations" element={<LocationsPage />} />
        <Route path="purchases" element={<PurchasesPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="import" element={<ImportPage />} />
        <Route path="catalog" element={<CatalogPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
